import type { ReactNode } from 'react';

interface BulkActionBarProps {
  readonly count: number;
  readonly actions: ReactNode;
}

/**
 * The strip that appears between a table's header and its rows once something
 * is selected.
 *
 * It says the count in words rather than leaving the operator to read it off
 * the checkboxes: every action on this bar is applied to a set nobody can see
 * all of at once on a scrolling table.
 */
export function BulkActionBar({ count, actions }: BulkActionBarProps) {
  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-2.5 border-t border-border bg-secondary px-[18px] py-2"
    >
      <span className="text-[13px] font-medium text-foreground">
        {count === 1 ? '1 selected' : `${String(count)} selected`}
      </span>
      <span className="ml-auto flex items-center gap-1.5">{actions}</span>
    </div>
  );
}
